export default {
    mr: 'Mr.',
    ms: 'Ms.',
    mrs: 'Mrs.',
    miss: 'Miss',
    dr: 'Dr.',
    me: 'Esq.',
};
